"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagZW = function FlagZW(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-83.66H-193v-31.28a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "39.34",
    width: "409.6",
    height: "38.34",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "77.68",
    width: "409.6",
    height: "38.34",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,108H216.6V139.3a7.07,7.07,0,0,1-7.06,7.06H-185.94A7.07,7.07,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "192.68",
    width: "409.6",
    height: "38.34",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "154.35",
    width: "409.6",
    height: "38.34",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-7H-36.34L-181.62-122h-4.32a7,7,0,0,0-4.7,1.87V144.49a7,7,0,0,0,4.7,1.87h4.32l145.28-115H216.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.64,144.49-23.51,12.18-190.64-120.13a7,7,0,0,0-2.36,5.19V139.3a7,7,0,0,0,2.36,5.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-124.15-39.46l14.88,30.15L-76-4.47-100.07,19l5.69,33.14L-124.15,36.5l-29.76,15.64L-148.23,19-172.31-4.47-139-9.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-85.54,16l-39.55-30.61c-4.63-10.85-11.2-17.84-16.79-17.84-4.74,0-7.06,4.39-7.72,7a7.83,7.83,0,0,0-4.25,4.87.72.72,0,0,0,.14.65.76.76,0,0,0,.6.29h.7c3.18-.08,8.48-.22,9.83,9.88.84,6.3-.41,17.59-4.4,26.1a18.91,18.91,0,0,0-1.82,11,.77.77,0,0,0,.82.6h.39l3.2,18.08a.76.76,0,0,0,.75.63H-95.9a.76.76,0,0,0,.74-.58l5.34-21.9v0s0,0,0,0l1.69-7,2,.24a.74.74,0,0,0,.78-.48.76.76,0,0,0-.24-.88Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-85.54,16l-39.55-30.61c-4.63-10.85-11.2-17.84-16.79-17.84-4.74,0-7.06,4.39-7.72,7a7.83,7.83,0,0,0-4.25,4.87.72.72,0,0,0,.14.65.76.76,0,0,0,.6.29h.7c3.18-.08,8.48-.22,9.83,9.88.84,6.3-.41,17.59-4.4,26.1a18.91,18.91,0,0,0-1.82,11,.77.77,0,0,0,.82.6h.39l3.2,18.08a.76.76,0,0,0,.75.63H-95.9a.76.76,0,0,0,.74-.58l5.34-21.9v0s0,0,0,0l1.69-7,2,.24a.74.74,0,0,0,.78-.48.76.76,0,0,0-.24-.88Zm-60.07,1c3.61-7.7,5.55-19.29,4.53-26.95-1.47-10.93-7.6-11.28-10.91-11.21a6.42,6.42,0,0,1,3.33-3,.74.74,0,0,0,.45-.55c.06-.25,1.35-6.21,6.33-6.21s11.15,6.87,15.47,17.09a.71.71,0,0,0,.24.3l37.56,29.08c-6.62-.8-23.92-3.18-34.17-7.22-5.35-2.11-6.57-5.33-7.65-8.16a.76.76,0,0,0-1-.43.75.75,0,0,0-.44,1c1.07,2.82,2.54,6.67,8.52,9,1.22.48,2.53.94,3.92,1.37-.25.73-1.78,4.45-8.57,6.9-5.51,2-9.43,5.31-10,8.32h-5.31V24.16c0-1.66,1.6-4.07,3.29-6.62,2.36-3.55,5-7.58,5-11.7a.76.76,0,0,0-.75-.75.76.76,0,0,0-.76.75c0,3.66-2.55,7.49-4.79,10.86-1.91,2.87-3.55,5.34-3.55,7.46v2.2l-2.63,0a18.52,18.52,0,0,1,1.8-9.37Zm30.06-4.8c-.88,2.43-3.47,3.26-5.4,3.52a9.9,9.9,0,0,0,3-4.19c.78.23,1.59.45,2.41.67Zm1.46.37,2.52.61c-.77,1.57-2.84,2.34-5.09,2.67a6.08,6.08,0,0,0,2.57-3.28Zm21.43,16.81c-7.69-2.37-29.86-3-43.76-3.06.47-1.72,2.65-4,6.35-5.8a.35.35,0,0,0,.11,0c20.74.07,35.18,3.15,38.49,3.92Zm-1,4-3-3.38a28.74,28.74,0,0,1,3.65.84Zm-39.2.53,1.48,1.39h-1.37c0-.45-.07-.92-.11-1.38Zm38.3,3.19-3.85-4.22a.75.75,0,0,0-1-.12l-4.52,3-3.41-3.73a.74.74,0,0,0-1-.09l-4.09,3.14-3.71-3.67a.77.77,0,0,0-1,0l-4,3.36-3.74-3.47a.76.76,0,0,0-1,0l-3.9,3.43-3.21-3c-.06-.89-.11-1.82-.15-2.78l2.87,2.82a.76.76,0,0,0,1,0l4-3.45,3.67,3.61a.75.75,0,0,0,1,0l4-3.36,3.87,3.65a.75.75,0,0,0,1,.05l4-3.11,3.39,3.89a.77.77,0,0,0,1,.12l4.5-3.21,4.47,5a.67.67,0,0,0,.19.14Zm-2.27-.24c-1.21-.16-2.9-.34-5.18-.52l2.92-2Zm-8.88-.79c-1.52-.09-3.22-.18-5.13-.27l2.87-2.2Zm-8.3-.41c-1.73-.06-3.62-.12-5.65-.17l3-2.49Zm-8.65-.24c-1.75,0-3.6-.07-5.56-.09l2.81-2.46ZM-132,27.91l4.88.09-2.56,2.2Zm8.71.18,4.92.16L-121,30.4Zm8.79.33c1.73.08,3.45.18,5.12.29l-2.66,2Zm8.7.55c1.87.15,3.64.32,5.27.52l-3,2.12Zm-40.22-1.08c2.28,0,6.36-.05,11.34,0a100.07,100.07,0,0,0,1.88,17.23H-143Zm49.57,17.23h-34.8a65.26,65.26,0,0,1-1.3-8.26c25.36.16,35,1.42,37.39,1.82a.78.78,0,0,0,.24.16ZM-91.11,23a179.52,179.52,0,0,0-35.52-3.92,22.29,22.29,0,0,0,3.46-1.72,27.63,27.63,0,0,0,3.44.21c3.46,0,8.32-.66,9.66-4.06,7.88,1.73,15.95,2.86,20.44,3.42Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-139.73-25.74a2.52,2.52,0,0,0-2.52-2.52,2.53,2.53,0,0,0-2.53,2.52,2.53,2.53,0,0,0,2.53,2.53,2.52,2.52,0,0,0,2.52-2.53Zm-2.52,1a1,1,0,0,1-1-1,1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.07,21.24a2.48,2.48,0,0,0-2.49,2.48,2.48,2.48,0,0,0,2.49,2.48,2.48,2.48,0,0,0,2.48-2.48,2.48,2.48,0,0,0-2.48-2.48Zm0,3.45a1,1,0,0,1-1-1,1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-113.65,21.66a2.49,2.49,0,0,0-2.48,2.48,2.48,2.48,0,0,0,2.48,2.49,2.49,2.49,0,0,0,2.49-2.49,2.49,2.49,0,0,0-2.49-2.48Zm0,3.45a1,1,0,0,1-1-1,1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagZW;
exports["default"] = _default;